import { Popover } from '@spotify-internal/encore-web';
import styled from 'styled-components';

export const PopoverStyled = styled(Popover)<{ $isNarrow: boolean }>`
  transform: ${({ $isNarrow }) =>
    $isNarrow ? 'translate(29px, 0)' : 'translate(-112px, 0)'};
`;
